<geaui-page-layout [headerTemplate]="header" [contentTemplate]="content" [sidebarTemplate]="sidebar">

  <div class="content">
    <ng-template #header>
      <geaui-header #header [noAuth]="noAuth"></geaui-header>
      <mat-spinner class="spinner" [diameter]="40" *ngIf="!noAuth && !contentReady"></mat-spinner>
    </ng-template>

    <ng-template #content>
      <!-- APP COMO TAL -->
      <div class="container" *ngIf="noAuth || contentReady" [ngStyle]="{'padding-left': sideBarOpen}">
        <router-outlet></router-outlet>
      </div>
    </ng-template>
  </div>

  <ng-template #sidebar>
    <geaui-sidebar-v2 [navigationItems]="data" [devisionName]="title"
      [devisionIconPath]="environment.appContentStorageURL + 'lpt/insightpartner-filtration/icons/40px_insightpartner-filtration.svg'"
      [bottomNavigation]="botItems" devisionIconBackgroundColor="var(--geaui-primary)">
    </geaui-sidebar-v2>
  </ng-template>
</geaui-page-layout>
